const { AIBulkPost } = window;

const api = {
    baseUrl: AIBulkPost?.restUrl || '/wp-json/aibp/v1/',
    nonce: AIBulkPost?.nonce || '',

    async request(endpoint, options = {}) {
        const url = this.baseUrl + endpoint;
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': this.nonce,
            },
            ...options,
        };

        if (config.body && typeof config.body === 'object') {
            config.body = JSON.stringify(config.body);
        }

        const response = await fetch(url, config);
        const text = await response.text();

        let data;
        try {
            data = JSON.parse(text);
        } catch (e) {
            throw new Error(`Server returned non-JSON response (${response.status}). Check WP error log.`);
        }

        if (!response.ok) {
            throw new Error(data.error || 'Request failed');
        }

        return data;
    },

    // Agents.
    getAgents() {
        return this.request('agents');
    },

    getAgent(id) {
        return this.request(`agents/${id}`);
    },

    createAgent(data) {
        return this.request('agents', { method: 'POST', body: data });
    },

    updateAgent(id, data) {
        return this.request(`agents/${id}`, { method: 'PUT', body: data });
    },

    deleteAgent(id) {
        return this.request(`agents/${id}`, { method: 'DELETE' });
    },

    toggleAgent(id) {
        return this.request(`agents/${id}/toggle`, { method: 'POST' });
    },

    runAgent(id) {
        return this.request(`agents/${id}/run`, { method: 'POST' });
    },

    duplicateAgent(id) {
        return this.request(`agents/${id}/duplicate`, { method: 'POST' });
    },

    // Models.
    getModels() {
        return this.request('models');
    },

    // Settings.
    getSettings() {
        return this.request('settings');
    },

    saveSettings(data) {
        return this.request('settings', { method: 'POST', body: data });
    },

    // Validate API key.
    validateKey(provider, apiKey) {
        return this.request('validate-key', {
            method: 'POST',
            body: { provider, api_key: apiKey },
        });
    },

    // Logs.
    getLogs(agentId = 0, offset = 0) {
        const params = new URLSearchParams();
        if (agentId) params.set('agent_id', agentId);
        if (offset) params.set('offset', offset);
        return this.request(`logs?${params.toString()}`);
    },

    // Categories (WP core REST API).
    getCategories() {
        const url = (AIBulkPost?.restUrl || '/wp-json/').replace('aibp/v1/', '') + 'wp/v2/categories?per_page=100&_fields=id,name';
        return fetch(url, {
            headers: { 'X-WP-Nonce': this.nonce },
        }).then(async (r) => {
            if (!r.ok) throw new Error('Failed to load categories');
            return r.json();
        });
    },

    // Stats.
    getStats() {
        return this.request('stats');
    },
};

export default api;
